import Avo from '../Avo';

const webPlayerSettingsButtonClicked = ({
  origin,
}: {
  origin: string;
}): void => {
  Avo.webPlayerSettingsButtonClicked({
    origin,
  });
};

export default webPlayerSettingsButtonClicked;
